var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMugHotLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "285F70DD-B469-4EB3-AB30-DF72D6FCB35B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-124.000000, -1532.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(7.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mug-hot-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,0 C5.5625,0 5,0.5625 5,1.25 C5,3.1796875 5.765625,5.0390625 7.1328125,6.3984375 L8.59375,7.859375 C9.4921875,8.765625 10,9.984375 10,11.25 C10,11.9375 10.5625,12.5 11.25,12.5 C11.9375,12.5 12.5,11.9375 12.5,11.25 C12.5,9.3203125 11.734375,7.4609375 10.3671875,6.1015625 L8.8984375,4.6328125 C8.0078125,3.734375 7.5,2.515625 7.5,1.25 C7.5,0.5625 6.9375,0 6.25,0 Z M2.5,17.5 L26.25,17.5 L27.5,17.5 L27.5,32.5 C27.5,35.2578125 25.2578125,37.5 22.5,37.5 L7.5,37.5 C4.7421875,37.5 2.5,35.2578125 2.5,32.5 L2.5,17.5 Z M30,17.5 L31.25,17.5 C34.703125,17.5 37.5,20.296875 37.5,23.75 C37.5,27.203125 34.703125,30 31.25,30 L30,30 L30,17.5 Z M30,32.5 L31.25,32.5 C36.0859375,32.5 40,28.5859375 40,23.75 C40,18.9140625 36.0859375,15 31.25,15 L27.5,15 L26.25,15 L2.5,15 C1.1171875,15 0,16.1171875 0,17.5 L0,32.5 C0,36.640625 3.359375,40 7.5,40 L22.5,40 C26.640625,40 30,36.640625 30,32.5 Z M17.5,1.25 C17.5,0.5625 16.9375,0 16.25,0 C15.5625,0 15,0.5625 15,1.25 C15,3.1796875 15.765625,5.0390625 17.1328125,6.3984375 L18.59375,7.859375 C19.4921875,8.765625 20,9.984375 20,11.25 C20,11.9375 20.5625,12.5 21.25,12.5 C21.9375,12.5 22.5,11.9375 22.5,11.25 C22.5,9.3203125 21.734375,7.4609375 20.3671875,6.1015625 L18.8984375,4.6328125 C18.0078125,3.734375 17.5,2.515625 17.5,1.25 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugHotLight);
export default __webpack_public_path__ + "static/media/mug-hot-light.39e4766ef36d4dc45135544675f9590e.svg";
export { ForwardRef as ReactComponent };